import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentColumnId: '',
    mainColumnId: '',
    articleId: ''
  },
  mutations: {
    updateCurrentColumnId (state, id) {
      state.currentColumnId = id
    },
    updateMainColumnId (state, id) {
      state.mainColumnId = id
    },
    updateArticleId (state, id) {
      state.articleId = id
    }
  },
  getters: {
    getColumnId: state => {
      return state.currentColumnId
    },
    getMainColumn: state => {
      return state.mainColumnId
    },
    getArticleId: state => {
      return state.articleId
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js